import PropTypes from "prop-types"
import React from "react"
import { usePageAssets } from "hooks/usePageAssets"
import Container from "components/ui/Container"
import Heading from "components/ui/Heading"
import SplitContainer from "components/ui/Layout/SplitContainer"

function FullyManagedOpenSourceBISection({ className }) {
  const { getAsset } = usePageAssets()
  const illustration = getAsset("internal-bi-fully-managed-open-source-bi-svg")
  return (
    <Container className={className} section>
      <SplitContainer
        className="py-10 lg:py-20 xl:py-32 2xl:py-40"
        image={illustration}
        imageClassName="mt-5 lg:mt-0 max-w-2xl w-full mx-auto"
        reversed
      >
        <Heading
          label="Open-Source Analytics, Enterprise Ready"
          title="Built and supported by Superset experts"
          subtitle={
            <>
              Escape proprietary lock-in with Apache Superset™, the world's
              leading open-source business intelligence (BI) platform. Preset,
              built by the team behind 75% of the Superset codebase, delivers
              enterprise-grade security and reliability without the constraints
              of traditional BI vendors.
            </>
          }
          narrow
        />
      </SplitContainer>
    </Container>
  )
}

FullyManagedOpenSourceBISection.propTypes = {
  /** Additional className(s) */
  className: PropTypes.string,
}

export default FullyManagedOpenSourceBISection
